import React from "react";
import { InlineNotification } from "@carbon/react";
import { useTranslation } from "react-i18next";
import "./serviceItemNotice.scss";

/**
 * SCRUM-44: a service item is only a general reference (code + name). Tells the
 * buyer that the specific detail is filled in later, on a purchase request or
 * when an RFQ is launched. Shown wherever a SERVICE item is created or edited.
 */
const ServiceItemNotice: React.FC = () => {
  const { t } = useTranslation();

  return (
    <InlineNotification
      kind="info"
      lowContrast
      hideCloseButton
      title={t("newMaterialForm.serviceNoticeTitle")}
      subtitle={t("newMaterialForm.serviceNotice")}
      className="service-item-notice"
    />
  );
};

export default ServiceItemNotice;
